module.exports = "img/alcaldesa-trabajando.2d99c1.jpeg";